export class AiChatConfigurationsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAiChatConfigurations(params) {
    return this.#http.get('/chat-configurations', { params, paramsSerializer: { indexes: null } });
  }

  async getAiChatConfigurationById(id) {
    return this.#http.get(`/chat-configurations/${id}`);
  }

  async createAiChatConfiguration(body) {
    return this.#http.post('/chat-configurations', body);
  }

  async updateAiChatConfiguration({ id, ...body }) {
    return this.#http.put(`/chat-configurations/${id}`, body);
  }

  async deleteAiChatConfiguration(id) {
    return this.#http.delete(`/chat-configurations/${id}`);
  }

  async getTemplates(params) {
    return this.#http.get('/chat-configurations/templates', { params });
  }

  async enableTemplate(id) {
    return this.#http.post(`/chat-configurations/${id}/enable`);
  }

  async disableTemplate(id) {
    return this.#http.post(`/chat-configurations/${id}/disable`);
  }

  async cloneTemplate(id) {
    return this.#http.post(`/chat-configurations/${id}/clone`);
  }
}
